import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {TranslationService} from "../../../metronic/core/_base/layout";
import {LanguageType} from "../../../metronic/core/_config/i18n/language-type.model";

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate {

  constructor(private _location: Location, private translationService: TranslationService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const locale = this.translationService.getCurrentLanguage();
    const externalUrl = next.data['externalUrl'];
    const externalEnUrl = next.data['externalEnUrl'];

    let finalUrl = externalUrl;

    if (externalEnUrl && locale === LanguageType.English) {
      finalUrl = externalEnUrl;
    }

    window.open(finalUrl, '_blank', 'noopener');
      return false;
  }
}
